export const primaryLanguage = process.env.PRIMARY_LANGUAGE || 'no';
export const secondaryLanguages = (process.env
  .SECONDARY_LANGUAGES as any as string[]) || ['en', 'es', 'ja'];
export const unfinishedLanguages = [] as string[];
export const languageNames = {
  en: 'English',
  es: 'Español',
  no: 'Norsk',
  ja: '日本語',
};
